import type { ErrorReporter, FuuzeError } from '@fuuze/shared';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

export class SentryReporter implements ErrorReporter {
  constructor() {
    if (import.meta.env.VITE_IS_LOCAL) return;

    Sentry.init({
      dsn: 'https://7a84e3eed3dd5d18b7973d8c2983735b@o4508460493045760.ingest.de.sentry.io/4508879405580368',
      integrations: [
        Sentry.replayIntegration(),
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.extraErrorDataIntegration({ depth: 5 }),
      ],
      environment: import.meta.env.VITE_ENV,
      // Tracing
      tracesSampleRate: 0.5, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        'localhost',
        'https://dev.web.fuuze.app',
        'https://web.fuuze.app',
        'https://dev.back.fuuze.app',
        'https://back.fuuze.app',
      ],
      // Session Replay
      replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }

  capture(error: FuuzeError) {
    Sentry.captureException(error);
  }
}
